import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categoryFilter", "accountSelector"]

  connect() {
    this.setupCategoryFilter()
    this.setupAccountSelector()
  }

  setupCategoryFilter() {
    if (!this.hasCategoryFilterTarget) return

    this.categoryFilterTarget.addEventListener('change', (e) => {
      const categoryId = e.target.value
      const rows = document.querySelectorAll('table.table tbody tr')

      if (categoryId === '') {
        rows.forEach(row => {
          row.style.opacity = '1'
        })
      } else {
        const klass = 'category-' + categoryId
        rows.forEach(row => {
          const hasCategory = row.querySelector('td.' + klass)
          row.style.opacity = hasCategory ? '1' : '0.3'
        })
      }
    })
  }

  setupAccountSelector() {
    const selector = this.element.querySelector('[data-finance-target="accountSelector"]')

    if (!selector) return

    selector.addEventListener('change', (e) => {
      const accountId = e.target.value
      const monthId = this.element.dataset.monthId

      if (monthId) {
        window.location.href = `/accounts/${accountId}/months/${monthId}`
      }
    })
  }
}

